<template>
    <button
        :disabled="disabled"
        @click="$emit('click')"
    >
        <slot />
    </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/Button.vue